// extracted by mini-css-extract-plugin
export var addToCartButton = "_oi-b";
export var arrowButtonContainer = "_oi-9";
export var arrowButtonIcon = "_oi-a";
export var carouselArrowButton = "_oi-6";
export var carouselElementContainer = "_oi-1";
export var left = "_oi-7";
export var productDisplayCarouselContainer = "_oi-0";
export var productTileContainer = "_oi-2";
export var productTileImage = "_oi-4";
export var productTileImageContainer = "_oi-3";
export var productTileTitle = "_oi-5";
export var right = "_oi-8";
export var sliderOverflow = "_oi-c";